<template>
    <div>
        <van-nav-bar style="height:0px" title="打卡" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
        <van-form v-for="(item, index) in this.info" :key="index" style="height: calc(100vh - 130px)">
            <van-field label="学号" v-model="item.xh" readonly input-align="right" />
            <van-field label="姓名" v-model="item.xm" readonly input-align="right" />
            <van-field label="院系" v-model="item.yx" readonly input-align="right" />
            <van-field label="专业" v-model="item.zy" readonly input-align="right" />
            <van-field label="班级" v-model="item.bj" readonly input-align="right" />
            <van-field label="指导老师" v-model="item.zdls" readonly input-align="right" />
            <van-field label="打卡时间" v-model="nowTime" readonly input-align="right" />
            <div style="height:0;width:0;overflow:hidden;">
                <el-amap ref="map" class="amap-box" :vid="'amap-vue'" :amap-manager="amapManager" :plugin="plugin"></el-amap>
            </div>
            <div class="position">
                <div class="title">
                    <div>您当前所在位置</div>
                    <div @click="rePosition">重新定位</div>
                </div>
                <div class="content">
                    <van-loading v-if="form.wz == ''" type="spinner" size="14" />
                    {{ form.wz || '定位获取中…' }}
                </div>
            </div>
            <div class="button-box" @click="onSubmit">
                <van-button round type="arr" native-type="submit">提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import iApi from '@/utils/internship';
import Calendar from './components/calendar';
import { AMapManager } from 'vue-amap';
let amapManager = new AMapManager();
export default {
    components: {
        Calendar
    },
    data() {
        let self = this;
        return {
            form: {
                wz: '',
                sj: ''
            },
            info: [],
            amapManager,
            plugin: [
                {
                    pName: 'Geolocation',
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 10000, //超过10秒后停止定位，默认：5s
                    buttonPosition: 'RB', //定位按钮的停靠位置
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                    events: {
                        init(o) {
                            // o 是高德地图定位插件实例
                            o.getCurrentPosition((status, result) => {
                                if (status == 'complete') {
                                    self.complete(result);
                                } else {
                                    self.$toast.fail('定位失败！');
                                }
                            });
                        }
                    }
                }
            ],
            nowTime: ''
        };
    },
    created() {
        this.getxsxx();
        this.nowTimes();
    },
    methods: {
        //获取学生信息接口
        async getxsxx() {
            const result = await iApi.getXsXx();
            this.info = result.data;
        },
        //显示当前时间（年月日时分秒）
        timeFormate(timeStamp) {
            let year = new Date(timeStamp).getFullYear();
            let month = new Date(timeStamp).getMonth() + 1 < 10 ? '0' + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
            let date = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
            let hh = new Date(timeStamp).getHours() < 10 ? '0' + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
            let mm = new Date(timeStamp).getMinutes() < 10 ? '0' + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
            let ss = new Date(timeStamp).getSeconds() < 10 ? '0' + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
            this.nowTime = year + '年' + month + '月' + date + '日' + ' ' + hh + ':' + mm + ':' + ss;
        },
        //当前时间
        nowTimes() {
            setInterval(() => {
                this.timeFormate(new Date());
            }, 500);
            this.clear();
        },
        //清楚当前的时间
        clear() {
            clearInterval(this.nowTimes);
            this.nowTimes = null;
        },
        complete(result) {
            this.form.wz = result.formattedAddress;
        },
        //定位
        rePosition() {
            this.form.wz = '';
            this.$refs.map[0].$plugins['AMap.Geolocation'].getCurrentPosition((status, result) => {
                if (status == 'complete') {
                    this.complete(result);
                } else {
                    this.$toast.fail('定位失败！');
                }
            });
        },
        //提交
        async onSubmit() {
            if (!this.nowTime) {
                return this.$toast('请选择时间');
            }
            if (!this.form.wz) {
                return this.$toast('请选择位置');
            }
            console.log('this.form.wz: ', this.form.wz);
            this.form.sj = this.nowTime;
            const res = await iApi.getSaveXsSxDk(this.form);
            console.log('res: ', res);
            if (res.code == '1') {
                this.$toast('提交成功');
                this.form = {
                    wz: '',
                    sj: ''
                };
            }
        }
    }
};
</script>
<style lang="less" scoped>
.position {
    margin-top: 10px;
    background: #ffffff;
    padding: 15px;
    .title {
        display: flex;
        justify-content: space-between;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
    }
    .content {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #b2b2b2;
        margin-top: 5px;
        display: flex;
        align-items: center;
        .van-loading {
            position: relative;
            left: 0;
            margin-right: 10px;
        }
    }
}
.button-box {
    background: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .van-button {
        width: 345px;
        height: 50px;
        background: #0189f9;
        border-radius: 25px !important;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/punchTheClock/index.vue